import { Chip, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { map } from 'lodash';
import React from 'react';

interface CountedToggleOption {
  label: string;
  value: string;
  count: number;
}

interface CountedToggleButtonGroupProps {
  options: readonly CountedToggleOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const CountedToggleButtonGroup: React.FC<CountedToggleButtonGroupProps> = ({ options, value, onChange }) => (
  <ToggleButtonGroup
    value={value}
    onChange={(_event, nextValue: string[]) => {
      if (nextValue.length > 0) {
        onChange(nextValue);
      }
    }}
    size="small"
  >
    {map(options, (option) => (
      <ToggleButton
        key={option.value}
        value={option.value}
        aria-label={`${option.label} ${option.count}`}
        disabled={option.count === 0}
        sx={(theme) => ({
          '&.Mui-selected': {
            color: theme.palette.primary.contrastText,
            bgcolor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:hover': {
              bgcolor: theme.palette.primary.dark,
              borderColor: theme.palette.primary.dark,
            },
            '& .MuiChip-root': {
              bgcolor: alpha(theme.palette.common.white, 0.16),
              color: 'inherit',
            },
          },
        })}
      >
        {option.label}
        <Chip
          component="span"
          label={option.count}
          size="small"
          sx={{
            height: 20,
            ml: 1,
            '& .MuiChip-label': {
              fontWeight: 700,
              px: 0.75,
            },
          }}
        />
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
